import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import OrdersApi from "../../../api/OrdersApi";
import {
  Button,
  Col,
  Empty,
  Image,
  Popconfirm,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
// import { useRecoilState } from "recoil";
import { env } from "../../../env/env";
import { Currency } from "../../util/Currency";
// import { memberState } from "../../../state/atoms";
import "../PrintCheckoutPage";
import { NavLink } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { prettifyPaperSize, removeDash, getPaginationTitle, getPrintCartSizeLabel } from "../../../util/utils";
import { OtherProducts } from "./OtherProducts";
import { logRemoveFromCart } from "../../../service/AnalyticsService";
import { ItemThumbsPreview } from "./ItemThumbsPreview";

const { Text, Paragraph } = Typography;
const { Option } = Select;

const locale = {
  emptyText: (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      imageStyle={{ height: 60 }}
      description={<span> No data yet to show</span>}
    />
  ),
};

export function Cart({ order, setOrder, setView, setCartCount }: any) {
  const [loading, setLoading] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(-1);
  const [priceLoadingIndex, setPriceLoadingIndex] = useState(-1);

  // const [member] = useRecoilState(memberState);

  useEffect(() => {
    if (window.location.href.includes('fromTimber=true')) {
      goToShipping();
    }
  })

  function editItem(designId: string, itemId: string) {
    setLoading(true);
    window.location.href = `${env.timberContextPath}/design?id=${designId}&open=print`;
  }

  function removeItem(item: any) {
    setLoadingIndex(order.items.indexOf(item));

    OrdersApi.removeItem(order.id, item.id).then((resp) => {
      setCartCount(resp.data.items?.length)

      setLoading(false);
      if (resp.data.items?.length === 0) {
        setView("empty");
      } else {
        resp.data.items = resp.data.items?.reverse();
        setOrder(resp.data);
      }
      setLoadingIndex(-1);

      logRemoveFromCart(resp.data);
    });
  }

  function goToShipping() {
    setView('shipping');
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  function changeQuantity(val: string, item: any) {
    setPriceLoadingIndex(order.items.indexOf(item));
    let newPrice = 0;
    let newShipping = 0;
    item.products.forEach((product: any) => {
      let foundQ = JSON.parse(product.quantities).find((q: any) => q.quantity === val);
      newPrice += parseFloat(foundQ.price);
      newShipping += parseFloat(foundQ.shippingFee);
    })
    OrdersApi.updateItemQuantity(order.id, item.id, val, newPrice.toString(), newShipping.toString()).then((resp) => {
      console.log(resp);
      resp.data.items = resp.data.items?.reverse();
      setOrder(resp.data);
      setPriceLoadingIndex(-1);
    }).catch((err) => {
      console.log(err);
      setPriceLoadingIndex(-1);
    })
  }

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <div className={"print-cart-page"}>
      {loading && <Skeleton />}

      {!loading && order && (
        <>
          <div className="cart">
            <h3>Your Cart</h3>

            <Table
              className={"desktop-table"}
              locale={locale}
              loading={loading}
              rowKey="id"
              columns={[
                {
                  title: "Preview",
                  dataIndex: "designId",
                  key: "designId",
                  width: 215,
                  render: (designId, item) => (
                    <Row gutter={8}>
                      <Col>
                        <ItemThumbsPreview item={item} />
                      </Col>
                    </Row>
                  )
                },
                {
                  title: "Product",
                  dataIndex: "designName",
                  key: "designName",
                  align: "left",
                  render: (designName, item) => (
                    <>
                      <Row gutter={16}>
                        <Col>
                          <Space direction="vertical" size={"small"}>
                            <Text strong>{designName}</Text>
                            <div className="edit-delete">
                              <EditOutlined onClick={() => editItem(item.designId, item.id)} />

                              <Popconfirm title={`Are you sure you want to remove ${item.designName} from the cart?`}
                                placement="left"
                                okText="Yes"
                                onConfirm={() => removeItem(item)}>
                                {loadingIndex !== order.items.indexOf(item) && <DeleteOutlined />}
                                {loadingIndex === order.items.indexOf(item) && <LoadingOutlined />}
                              </Popconfirm>
                            </div>
                            <Paragraph className={"design-info"}>
                              {prettifyPaperSize(item.paperSize)} {getPrintCartSizeLabel(item.designSize)} - {item.pages} {item.pages === 1 ? 'page' : 'pages'}
                              <br />
                              <span className={"cap"}>{removeDash(item.paperType)}</span>
                              <br />
                              {getPaginationTitle(item.pagination)}
                              <br />
                              {item.quantity} Copies
                              <br />
                              {item.designSize.indexOf('gift-certificate') > -1 && <span>Starting Number {item.gcStartingNumber}</span>}
                            </Paragraph>
                          </Space>
                        </Col>
                      </Row>
                    </>
                  ),
                },
                {
                  title: "Quantity",
                  dataIndex: "quantity",
                  key: "quantity",
                  align: "center",
                  render: (quantity, item) =>
                    <Select defaultValue={quantity} onChange={(val) => changeQuantity(val, item)}>
                      {JSON.parse(item.products[0].quantities).sort(function (a: any, b: any) {
                        return a.quantity - b.quantity;
                      }).map((q: any) =>
                        <Option key={q.quantity} value={q.quantity}>{q.quantity}</Option>
                      )}
                    </Select>
                },
                {
                  title: "Total",
                  dataIndex: "price",
                  key: "price",
                  align: "right",
                  render: (price, item) =>
                    <>
                      <Text strong>
                        {priceLoadingIndex !== order.items.indexOf(item) && <Currency>{price}</Currency>}
                        {priceLoadingIndex === order.items.indexOf(item) && <LoadingOutlined />}
                      </Text>
                    </>
                },
              ]}
              dataSource={order.items}
              pagination={false}
            />

            <div className={"mobile-table"}>
              {order.id && order.items.map((item: any) => (
                <div className={`item ${item.id === (editItem as any).id ? 'hidden' : ''}`} key={item.id}>
                  <div className="thumb">
                    <Image
                      alt={item.designName}
                      loading="eager"
                      src={`${env.rendererPath}/design/thumbnail/${item.designId}?height=${env.rendererImageHeight}`}
                      preview={false}
                      placeholder={<LoadingOutlined style={{ fontSize: 40, position: 'absolute', color: '#bbb', top: '40%', left: '40%' }} />}
                    />
                  </div>

                  <div className="info">
                    <div className="name">{item.designName}</div>
                    <div>{prettifyPaperSize(item.paperSize)} {getPrintCartSizeLabel(item.designSize)} - {item.pages} {item.pages === 1 ? 'page' : 'pages'}</div>
                    <div className="cap">{removeDash(item.paperType)}</div>
                    <div>{getPaginationTitle(item.pagination)}</div>
                    <div>{item.quantity} Copies</div>
                    <div className="price">${item.price.toFixed(2)}</div>
                    {item.designSize.indexOf('gift-certificate') > -1 && <span>Starting Number {item.gcStartingNumber}</span>}
                  </div>

                  <div className="edit-delete">
                    <EditOutlined className="edit-btn" onClick={() => editItem(item.designId, item.id)} />
                    {order.items.indexOf(item) !== loadingIndex &&
                      <div className="delete-btn" onClick={() => removeItem(item)}>
                        <DeleteOutlined />
                      </div>}
                    {order.items.indexOf(item) === loadingIndex &&
                      <div className="delete-btn">
                        <LoadingOutlined />
                      </div>}
                  </div>
                </div>
              ))}
            </div>

            <Row className="totals">
              <Col span={7} offset={17}>
                <Row justify="space-between">
                  <Col>Subtotal:</Col>
                  <Col><Currency>{order.subtotal}</Currency></Col>
                </Row>

                {order.state && order.zip ?
                  <Row justify="space-between">
                    <Col>Shipping &amp; Processing:</Col>
                    <Col><Currency>{order.shipping}</Currency></Col>
                  </Row>
                  : ''
                }

                {order.tax ?
                  <Row justify="space-between">
                    <Col>Tax:</Col>
                    <Col><Currency>{order.tax}</Currency></Col>
                  </Row>
                  : ''
                }

                {order.discount ?
                  <Row justify="space-between">
                    <Col>Discount:</Col>
                    <Col><>- <Currency>{order.discount}</Currency></></Col>
                  </Row> : ''
                }

                <Row justify="space-between" className="total">
                  <Col>Total:</Col>
                  <Col><Currency>{order.total}</Currency></Col>
                </Row>

                <Space direction="vertical" style={{ width: '100%' }} className="footer-btns">
                  <Button type={"primary"} style={{ fontWeight: 'bold' }} size="large" block loading={loading} disabled={loading} onClick={goToShipping}>
                    Checkout
                  </Button>

                  <div className={"add-more"}>
                    <NavLink to={`${env.dashboardPath}/designs`}>
                      Add more designs &gt;
                    </NavLink>
                  </div>
                </Space>
              </Col>
            </Row>
          </div>

          <OtherProducts page="cart" />
        </>
      )}
    </div>
  );
}
